<template>
    <v-row justify="center" class="border-radius-2">
        <v-dialog
            v-model="dialog"
            persistent
            width="450"
            content-class="border-radius-2 pa-13 elevation-0"
            hide-overlay
        >
            <v-card class="border-radius-2 position-relative" color="#e9f5f4">
                <div data-cy="hexagon-badge-container" class="d-flex justify-center badges-content dialog-top position-absolute">
                    <HexagonBadge
                        :class="
                            'hexagon-badge ' +
                            (currentQuestionIndex === index ? 'badge-active ' : '')
                        "
                        v-for="(badge, index) of survey.preguntas"
                        :key="index"
                        ><span class="hexagon-number">{{ index + 1 }}</span></HexagonBadge
                    >
                </div>
                <div class="pt-10 pa-8 elevation-6">
                    <v-card-title class=" d-flex justify-start mt-5 pa-0"
                        ><span
                            class="titles text-h6 text-left font-weight-regular primary--text d-flex justify-start"
                            >{{ $t('initialTour.questions') }}</span
                        ></v-card-title
                    >
                    <v-container class="pa-0">
                        <QuestionContent
                            v-for="(question, index) of survey.preguntas"
                            :key="index"
                            :visible="currentQuestionIndex === index"
                            :question="question"
                            :question_index="index"
                        ></QuestionContent>
                    </v-container>
                    <v-card-actions class="d-flex justify-center">
                        <v-btn
                            data-cy="continue-button-poll"
                            color="secondary"
                            large
                            rounded
                            v-if="!finish"
                            class="w-100"
                            @click="nextQuestion"
                            >{{ $t('initialTour.next_question') }}</v-btn
                        >
                        <v-btn
                            data-cy="finish-button-poll"
                            color="secondary px-15"
                            v-if="finish"
                            large
                            rounded
                            :loading="btnLoaded"
                            class="w-100 font-weight-thin"
                            @click="nextPass"
                            >{{ $t('initialTour.continue') }}</v-btn
                        >
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
    </v-row>
</template>
<script>
/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */

import { mapState, mapActions } from 'vuex'

import SurveyService from '@/services/survey'

import HexagonBadge from './SurveyCore/HexagonBadge.vue'
import QuestionContent from './SurveyCore/QuestionContent.vue'

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    components: {
        HexagonBadge,
        QuestionContent,
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            survey: (state) => state.userData.survey,
            survey_answer: (state) => state.userData.survey_answer,
        }),
        greetWelcomeMessage() {
            const genre =
                this.$i18n.locale === 'es' ? (this.user.genre === 'FEMALE' ? 'a' : 'o') : ''
            return `${this.$t('initialTour.greet_wellcome', { genre })} ${
                this.user.firstname.split(' ')[0]
            }!`
        },
    },
    data() {
        return {
            currentQuestionIndex: 0,
            finish: false,
            btnLoaded: false,
        }
    },
    methods: {
        ...mapActions('dashboard', ['showFinishSurveyModal', 'showInitialPoll']),
        ...mapActions('userData', ['setSurvey']),
        async nextPass() {
            const value = this.evaluateValue()
            if (value) {
                this.btnLoaded = true
                this.currentQuestionIndex += 1
                await SurveyService.uploadSurveyAnswers(this.survey_answer).catch((err) =>
                    console.error(err)
                )
                this.setSurvey(null)
                this.showInitialPoll()
                this.showFinishSurveyModal()
                this.btnLoaded = false
            }
        },
        nextQuestion() {
            const value = this.evaluateValue()
            const { preguntas } = this.survey
            if (value) {
                this.currentQuestionIndex += 1
            }
            if (this.currentQuestionIndex === preguntas.length - 1) {
                this.finish = true
            }
        },
        evaluateValue() {
            const { preguntas } = this.survey
            let radioValue = null
            const element = document.querySelector(
                `input[name='item-${preguntas[this.currentQuestionIndex].id}']:checked`
            )
            if (element) radioValue = element.value
            else {
                this.$modal.error(this.$t('initialTour.select_option'))
                return null
            }

            if (radioValue) {
                this.survey_answer.answers.push({
                    item: preguntas[this.currentQuestionIndex].numberQuestion,
                    questionNumber: preguntas[this.currentQuestionIndex].numberQuestion,
                    questionAnswer: Number(radioValue),
                })
            } else {
                this.$modal.error(this.$t('initialTour.select_option'))
                return null
            }
            return radioValue
        },
    },
    mounted() {
        if (!this.survey) return
        this.survey_answer.userId = this.user.id
        this.survey_answer.surveyId = this.survey.id
        this.userId = this.user.id
    },
}
</script>
<style>
.dialog-top {
    position: absolute;
    z-index: 101;
    top: -6vh;
    width: inherit;
}
.hexagon-number {
    font-family: 'Patua One', cursive !important;
    font-weight: 500;
    font-size: 24px;
    color: #ffb422;
}

.badge-active .hexagon-number {
    color: #ff7a22;
}

/* tr:nth-child(odd) o tr:nth-child(2n+1)
Representa las filas impares de una tabla HTML: 1, 3, 5, etc.
tr:nth-child(even) o tr:nth-child(2n)
Representa las filas pares de una tabla HTML: 2, 4, 6, etc. */

.badges-content > .hexagon-badge:nth-child(2n + 1) {
    margin-top: 25px;
    margin-left: -15px;
}
.badges-content > .hexagon-badge:nth-child(2n) {
    margin-left: -15px;
}
</style>
